import { render, staticRenderFns } from "./VeloAboManage.vue?vue&type=template&id=1a932a15&"
import script from "./VeloAboManage.vue?vue&type=script&lang=js&"
export * from "./VeloAboManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports